import React from 'react'
import FriendListPageOne from './FriendListPageOne'
import FriendListPageTwo from './FriendListPageTwo'

const FriendListExercise = ({ section, questions }) => {
  return (
    <div>
      {section === 0 && <FriendListPageOne />}
      {section === 1 && <FriendListPageTwo questions={questions} />}
    </div>
  )
}

export default FriendListExercise
